import enrollment from './enrollment'
import user from './user'
import userSettings from './userSettings'

export default {
  enrollment,
  user,
  userSettings,
}
